/**
 * Cently — automatic coupons and cashback
 *
 * Exposes one web-accessible-resource entry to every origin with no `use_dynamic_url`,
 * covering `siteScript.js`, `redirectionChainSiteScript.js`, `images/*`, `fonts/*` and
 * `merchantTermsPage.html`. All resolve at fixed URLs from any page.
 *
 * The `images/best-price.png` asset is the primary signal — an image, so `probeImage`
 * reaches it without a CORS grant — corroborated by the vendor-named `siteScript.js`
 * content script and the `merchantTermsPage.html` page.
 *
 * Manifest verified against version 7.46.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kegphgaihkjoophpabchkmpaknehfamb';

export const cently: ExtensionDefinition = {
  id: ID,
  name: 'Cently: Automatic Coupons + Cashback for Free',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'One static WAR on every origin including siteScript.js and the images folder, with ' +
    'no dynamic URL. Detection is a single load and conclusive.',
  signals: [
    {
      id: 'war-best-price-image',
      kind: 'web-accessible-resource',
      description:
        'Load images/best-price.png via <img> — exposed to every origin and readable ' +
        'without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/best-price.png'),
    },
    {
      id: 'war-site-script-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch siteScript.js — a vendor-named injected script exposed to every origin.',
      weight: 0.5,
      run: () => probeFetch(ID, 'siteScript.js'),
    },
    {
      id: 'war-merchant-terms-html',
      kind: 'web-accessible-resource',
      description: 'Fetch merchantTermsPage.html — a named page entry, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'merchantTermsPage.html'),
    },
  ],
};
